import { render, staticRenderFns } from "./ProveedorShow.vue?vue&type=template&id=234b0f17&"
import script from "./ProveedorShow.vue?vue&type=script&lang=js&"
export * from "./ProveedorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports